const icons = {
  activity: (
    <path d="M3 12h4l2.4-6 5.2 12L17 12h4" />
  ),
  alert: (
    <>
      <path d="M12 3 2.8 19a1.2 1.2 0 0 0 1.1 1.8h16.2a1.2 1.2 0 0 0 1.1-1.8L12 3Z" />
      <path d="M12 8v5" />
      <path d="M12 17h.01" />
    </>
  ),
  chart: (
    <>
      <path d="M4 19V5" />
      <path d="M4 19h16" />
      <path d="m7 15 3-4 3 2 4-7 3 3" />
    </>
  ),
  coin: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M9 9.5c.8-1 2.4-1.3 3.8-.8 1 .4 1.6 1.1 1.6 2 0 1.3-1.1 1.9-2.5 2.2-1.8.4-2.8.7-2.8 1.9 0 1 1 1.8 2.7 1.8 1.4 0 2.4-.5 3.1-1.3" />
      <path d="M12 6.8v10.4" />
    </>
  ),
  database: (
    <>
      <ellipse cx="12" cy="6" rx="7" ry="3" />
      <path d="M5 6v6c0 1.7 3.1 3 7 3s7-1.3 7-3V6" />
      <path d="M5 12v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" />
    </>
  ),
  shield: (
    <path d="M12 3 5 6v5c0 4.4 2.8 8.2 7 10 4.2-1.8 7-5.6 7-10V6l-7-3Z" />
  ),
  spark: (
    <>
      <path d="M12 3v5" />
      <path d="M12 16v5" />
      <path d="M4.2 7.2 7.7 10.7" />
      <path d="m16.3 13.3 3.5 3.5" />
      <path d="M3 12h5" />
      <path d="M16 12h5" />
      <path d="m4.2 16.8 3.5-3.5" />
      <path d="m16.3 10.7 3.5-3.5" />
    </>
  ),
  wallet: (
    <>
      <path d="M4 7.5A2.5 2.5 0 0 1 6.5 5H18a2 2 0 0 1 2 2v10.5a2 2 0 0 1-2 2H6.5A2.5 2.5 0 0 1 4 17V7.5Z" />
      <path d="M16 12h4v4h-4a2 2 0 0 1 0-4Z" />
    </>
  ),
};

export default function InlineIcon({ name = "activity", className = "h-4 w-4" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {icons[name] ?? icons.activity}
    </svg>
  );
}
